import { p as proxyCustomElement, H, h, c as Host } from './p-DWmaQhSz.js';
import { d as defineCustomElement$1 } from './p-BrGjr5zY.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.3.0
 */

const TdsSidenavPopover = /*@__PURE__*/ proxyCustomElement(class TdsSidenavPopover extends H {
    constructor() {
        super();
        this.__registerHost();
        /**
         * Maximum screen width at which the popover will be displayed
         */
        this.popoverMaxScreenWidth = "720px";
        // --------------------------------------------------------------------------
        //
        //  Private Methods
        //
        // --------------------------------------------------------------------------
        this.handleResize = () => {
            const maxWidth = parseInt(this.popoverMaxScreenWidth);
            const windowWidth = window.innerWidth;
            if (windowWidth < maxWidth) {
                this.popoverRef.setAttribute("popover", "auto");
            }
            else {
                this.popoverRef.removeAttribute("popover");
            }
        };
        this.removeResizeObserver = () => {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        };
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentWillLoad() {
        var _a;
        const parentNavId = (_a = this.el.closest("nav")) === null || _a === void 0 ? void 0 : _a.id;
        if (!parentNavId) {
            throw new Error("Sidenav popover must be a child of a nav element");
        }
        this.popoverId = `${parentNavId}-popover`;
    }
    componentDidLoad() {
        this.resizeObserver = new ResizeObserver(() => {
            this.handleResize();
        });
        this.resizeObserver.observe(document.body);
    }
    disconnectedCallback() {
        this.removeResizeObserver();
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '96b3d33d4f2e9f1008379743520d01c91e5dbce6' }, h("tds-popover-container", { key: 'a9c3103a62caa369e48c71ffe109d34bfbe05ec2', id: this.popoverId, class: "tds-sidenav-collapse", autoPosition: true, ref: (e) => (this.popoverRef = e) }, h("div", { key: '3f6eb3de5f0690e603df1e1ea26a0050d9a66515', class: "tds-sidenav-scroll-container" }, h("slot", { key: '6b0038e4bd5320914456515bdc7711cb1d694cd3' })))));
    }
    get el() { return this; }
}, [6, "tds-sidenav-popover", {
        "popoverMaxScreenWidth": [1, "popover-max-screen-width"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-popover", "tds-popover-container"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-popover":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, TdsSidenavPopover);
            }
            break;
        case "tds-popover-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { TdsSidenavPopover as T, defineCustomElement as d };
//# sourceMappingURL=p-CDOqC5he.js.map
